import { render, staticRenderFns } from "./DirectOrder.vue?vue&type=template&id=20023a62&scoped=true"
import script from "./DirectOrder.vue?vue&type=script&lang=js"
export * from "./DirectOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20023a62",
  null
  
)

export default component.exports